import styled from 'styled-components';

export const TokenInputContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const Digit = styled.div`
  font-size: ${({ theme }) => theme.texts.typeScale(3)}px;
  width: 24px;
  min-height: 37px;
  text-align: center;
`;

export const DigitContainer = styled.div<{ focused: boolean }>`
  display: flex;
  flex-direction: row;
  cursor: text;
  align-items: center;
  justify-content: center;
  margin: 0px 4px;
  border-bottom: 2px solid
    ${({ focused, theme }): string =>
      focused ? theme.colors.ctaBlue(-1) : theme.colors.ctaBlue(3)};
`;

export const HiddenTextInput = styled.input.attrs({ type: 'numeric' })`
  display: block;
  height: 0;
  width: 0;
  outline: none;
  border: none;
`;
